// init-app.ts
import { isPrinting, windowSize } from "@adornis/base/client/frontend-helpers/window-size.js";
import { render } from "lit";
import { combineLatest, takeUntil } from "rxjs";
import { errorBoundary } from "./error-boundary.js";
import { stateful } from "./stateful.js";
import { cordovaKeyboardShown, intrinsicHeight } from "./viewport.js";
var connected = false;
var rootElement = new Promise(
  (resolve) => rootElResolver = (value) => {
    if (connected)
      throw new Error("there should only be one root element!");
    connected = true;
    resolve(value);
  }
);
var rootElResolver;
function updateComponentHeight(target, height, printing) {
  target.style.display = "block";
  if (!printing) {
    target.style.height = `${height}px`;
    target.style.position = "fixed";
  } else {
    target.style.height = "unset";
    target.style.position = "unset";
  }
  document.body.style.height = `${height}px`;
  document.querySelector("html").style.overflow = "hidden";
  target.style.width = "100%";
}
async function initApp(renderApp) {
  const target = document.getElementById("root");
  if (!target || !(target instanceof HTMLElement)) {
    throw new Error(
      'Could not find #root, your skeleton is not up to date. HTML needs to contain a <div id="root"></div>'
    );
  }
  const root = target.getRootNode();
  if (root !== window.document) {
    throw new Error("Root element can only be used in window.document");
  }
  rootElResolver(target);
  await document.fonts.ready;
  combineLatest([intrinsicHeight, isPrinting]).pipe(takeUntil(new Promise((resolve) => target.addEventListener("disconnected", resolve)))).subscribe(([height, printing]) => updateComponentHeight(target, height, printing));
  combineLatest([cordovaKeyboardShown, windowSize, isPrinting]).pipe(takeUntil(new Promise((resolve) => target.addEventListener("disconnected", resolve)))).subscribe(([keyboardShown]) => {
    if (keyboardShown) {
      document.body.style.position = "fixed";
      document.body.style.top = "0";
      document.body.style.bottom = "0";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "unset";
      document.body.style.top = "unset";
      document.body.style.bottom = "unset";
      document.body.style.width = "100%";
    }
  });
  if (renderApp instanceof Function) {
    render(stateful(errorBoundary(renderApp))(), target);
  } else {
    render(renderApp.render(), target);
  }
}
export {
  initApp,
  rootElement
};
